import { ZoomResultInterface } from "@nts/std/interfaces";
import { Expose } from "@nts/std/serialization";

export class ZoomResult implements ZoomResultInterface {

  @Expose()
  result: string;

  static empty(): ZoomResult {
    return new ZoomResult('');
  }

  constructor(result: string) {
    this.result = result;
  }
}
